import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "../ui/accordion";

// Reusable accessible FAQ accordion (used on home + templates).
export default function FAQAccordion({ faqs = [], testIdPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={`${testIdPrefix}-accordion`}>
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
          <AccordionTrigger
            className="text-left font-serif text-xl md:text-2xl text-primary hover:text-accent hover:no-underline py-6 [&>svg]:text-accent [&>svg]:w-5 [&>svg]:h-5"
            data-testid={`${testIdPrefix}-trigger-${i}`}
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-[15px] text-secondary-foreground leading-relaxed pb-6 pr-8 font-sans">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
